import React from 'react';
import {Section, Container, Row, Column, Image, Title, Text, StyledLink} from '../styles/AboutStyles';
import { Link } from 'react-router-dom';


const About = () => {
  return (
    <Section>
      <Container>
        <Row>
          <Column >
            <Image
              src="/assets/images/women.jpg"
              alt="About Us"
            />
          </Column>
          <Column>
            <Title>About Sophia Matthew</Title>
            <Text>
              Sophia Matthews is a highly respected real estate agent known for her exceptional
              knowledge of the New York City market. With over 10 years of experience, she has
              become a trusted advisor to both local residents and out-of-town buyers. Sophia
              specializes in luxury properties, from high-rise apartments in Manhattan to charming
              brownstones in Brooklyn. Her deep understanding of the city's diverse neighborhoods,
              combined with her keen eye for detail and market trends, allows her to provide clients
              with the best possible real estate options. Known for her integrity, professionalism,
              and commitment, Sophia works tirelessly to ensure that every client finds their
              perfect home. Whether you’re buying your first apartment or looking for an investment
              property, Sophia’s personalized approach will guide you through every step of the
              process.
            </Text>
            <StyledLink as={Link} to="/aboutInfo">Know More</StyledLink>
          </Column>
        </Row>
      </Container>
    </Section>
  );
};

export default About;
